import React from 'react';
import { Dialog, DialogContent, Typography, Box } from '@mui/material';
import { Button } from '../../../components/Button/button';
import { region } from '../../../config/images';

const DeleteMachineryPopup = ({
  open,
  onClose,
  handleDelete,
  loading,
  translations,
  language
}) => {
  return (
    <Dialog
      open={open}
      maxWidth="xs"
      disableScrollLock
      PaperProps={{
        sx: { borderRadius: "12px" },
      }}
    >
      <DialogContent className="p-5" style={{ textAlign: "center" }}>
        <Box>
          <img src={region.correct} alt="" />
        </Box>
        <Typography variant="h5" className="pt-4 mb-2">
          <b>{translations[language].deleteMachinery}</b>
        </Typography>
        <Typography
          variant="p"
          className="pt-4"
          style={{ fontSize: "16px" }}
        >
          {translations[language].deleteMachineryConfirmation}
        </Typography>
        <div className="d-flex gap-3 pt-4">
          <Button
            title={translations[language].yes}
            classname={"assign-task-button"}
            onClick={handleDelete}
            loading={loading}
          />
          <button className="assign-task-button" onClick={onClose}>
            {translations[language].no}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteMachineryPopup;